import React from 'react';
import { Image, Text } from 'wix-ui-tpa/cssVars';
import { isExternalImage } from '../utils/drawer';
import styles from './signature-image-wut.module.scss';
export const SignatureImageWUT = _ref => {
  let {
    id,
    value
  } = _ref;
  if (!value || !isExternalImage(value)) {
    return null;
  }
  const image = value.url ? /*#__PURE__*/React.createElement("img", {
    id: id,
    src: value.url,
    alt: value.displayName,
    className: styles.externalImage,
    "data-hook": "signature-image"
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
    className: styles.externalImageIcon,
    "data-hook": "signature-image"
  }), /*#__PURE__*/React.createElement(Text, {
    id: id
  }, value == null ? void 0 : value.displayName));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, image);
};
//# sourceMappingURL=signature-image-wut.js.map